export default "__VITE_ASSET__b4r6p$O5__"